/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponse interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponse(value) {
    if (!('Token' in value) || value['Token'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponseFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Token': json['Token'],
    };
}
export function FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponseToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Token': value['Token'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponse.js.map